export default `
You will be given one **worksheet JSON**.

Locate **every entry** at the path  
…block*.data.backend.question_variables[]

Produce a concise **Variables Insight** list as follows:

────────────────────────────────
### Variables Insight

* **<varName>**  
  • Type (string | number | boolean | object | array)  
  • Default / Init value  
  • Structure – briefly describe sub‑fields if the value is JSON‑encoded, a row‑col coordinate ("r:c"), URL, etc.  
  • Used in – name each component / runtime function that references this variable (search the JSON for matches).  
  • Role – one‑sentence explanation of what the variable controls in the game / grading flow.

* **<nextVar>**  
  • …

────────────────────────────────
Extraction rules
1. Treat the array under question_variables as the authoritative source of globals.
2. Parse JSON‑encoded strings mentally and summarise their shapes.
3. For coordinate strings like "6:0", state they reference a table cell (row 6, col 0).  
4. For URLs, note whether they point to images, audio, etc.  
5. Include only variables found in question_variables; ignore anything else.
6. Keep each bullet short, technical, and copy‑paste‑ready.  
7. Return **only** the “Variables Insight” block above—no extra preamble, no JSON echo, no additional prose.

`;
